import { axios } from '@src/plugins/axios'

export default class EvaluacionesApiRepository {
  static async fetchConjuntoEvaluaciones(idPersonal) {
    const { data } = await axios.get(`/PoliciaCuadrantes/DesarrolloPolicial/personal/${idPersonal}/evaluacionTrianual`)
    return data.data
  }

  static async createConjuntoEvaluaciones({
    fk_idRespetoPrincipios = null,
    fk_idDisciplinaAdministrativa = null,
    fk_idDisciplinaOperativa = null,
    fk_idProductividad = null,
    fk_idRespetoPrincipiosValores = null,
    fk_idDesempenioInstitucional = null,
    fk_idRendimientoProfesionalismo = null,
    idPersonal,
  }) {
    const payload = {
      fk_idRespetoPrincipios,
      fk_idDisciplinaAdministrativa,
      fk_idDisciplinaOperativa,
      fk_idProductividad,
      fk_idRespetoPrincipiosValores,
      fk_idDesempenioInstitucional,
      fk_idRendimientoProfesionalismo,
    }

    await axios.post(`/PoliciaCuadrantes/DesarrolloPolicial/personal/${idPersonal}/evaluacionTrianual`, payload)
  }
}
